import { render, staticRenderFns } from "./PackageSummary.vue?vue&type=template&id=cb2822fc&scoped=true&"
import script from "./PackageSummary.vue?vue&type=script&lang=js&"
export * from "./PackageSummary.vue?vue&type=script&lang=js&"
import style0 from "./PackageSummary.vue?vue&type=style&index=0&id=cb2822fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2822fc",
  null
  
)

export default component.exports